import { useEffect, useState } from "react"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { AMANAGE_APP_SETTING_API, IMAGE_URL } from "../../../../Utilities/APIs/APIs"


function ViewAppSettings({   targetID, employee}) {

    const [appSettings, setAppSettings] = useState(null)
    // console.log("🚀 ~ ViewAppSettings ~ category:", appSettings)

    const axiosInstance = useAxiosInstance()

    useEffect(() => {

        async function fetchAndSetCategory() {

            const { data } = await axiosInstance.get(AMANAGE_APP_SETTING_API + 'getSingleAppSettings/' + targetID)
            setAppSettings(data);
        }
        fetchAndSetCategory()
    }, [axiosInstance, targetID])

    return (
        <div className="crud_view_content">

            {appSettings &&
                <>
                   
                    <h1>Name</h1>
                    <p>{appSettings?.name}</p>

                    <h1>Availability</h1>
                  <p>{appSettings?.isCategoryFeatured === true ? 'TRUE' : 'FALSE'}</p>

                <>
                    <h1>Image</h1>
                    <img
                        src={IMAGE_URL + appSettings.image}
                        alt={appSettings.name ? appSettings.name : 'image'}
                    />
                </>

                </>
            }
        </div>
    )
}

export default ViewAppSettings